import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GoalReviewDto, SivaManagementService } from 'src/api/v2';
import { SIVA_GOALS_DETAILS_LIST_KEY } from 'src/constants/hook-keys';

export function useGoalReviewMutation({
  clusterId,
  goalAccomplishmentId,
  year,
}: {
  clusterId: string;
  goalAccomplishmentId: string;
  year: number;
}) {
  const [service] = useState(() => new SivaManagementService());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (record: GoalReviewDto) => {
      return await service.reviewDetails(goalAccomplishmentId, record);
    },
    onSettled() {
      queryClient.invalidateQueries([SIVA_GOALS_DETAILS_LIST_KEY, clusterId, year]);
    },
  });
}
